export const MAX_FILES_SIZE = 256000;
export const FILE_SIZE_EXCEEDS_ERROR = 'Total files size exceeds 250kb';
